import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { FieldTree, FormField } from "@angular/forms/signals";
import {  OwnershipTypeModel, OwnershipTypesFilterModel } from "./search-filter-ownership.model";

@Component({
    selector: "search-filter-ownership",
    imports: [FormField],
    templateUrl: "./search-filter-ownership.component.html",
    styleUrl: "./search-filter-ownership.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchFilterOwnershipComponent {
    filterForm = input.required<FieldTree<OwnershipTypesFilterModel>>();

    toggleExpanded(): void {
        this.filterForm().expanded().value.set(!this.filterForm().expanded().value());
    }

    toggleSelectedOwnership(ownershipType: OwnershipTypeModel): void {
         const current = this.filterForm().ownershipTypes().value();
        this.filterForm()
            .ownershipTypes()
            .value.set(current.map((e) => (e.index === ownershipType.index ? { ...e, selected: !e.selected } : e)));        
    }

    selectAllOwnershipTypes(): void {
        if (this.checkIfAllSelected()) {
            this.filterForm().ownershipTypes().value.update((ownershipTypes: OwnershipTypeModel[]) => {
                return ownershipTypes.map((ownershipType) => {
                    return {
                        ...ownershipType,
                        selected: false,
                    };
                });
            });
        } else {
            this.filterForm().ownershipTypes().value.update((ownershipTypes: OwnershipTypeModel[]) => {
                return ownershipTypes.map((ownershipType) => {
                    return {
                        ...ownershipType,
                        selected: true,
                    };
                });
            });
        }
    }

    private checkIfAllSelected(): boolean {
        return this.filterForm()
            .ownershipTypes()
            .value()
            .every((ownershipType) => ownershipType.selected);
    }
}
